<section id="alternative-page">
    <div class="alternative-page-title">
        <h4 class="ps-3 text-start">{{'ALTERNATIVE.DISPUTE.TEXT' | translate}}</h4>
    </div>
    <div class="alternative-content pb-5">
        <section id="text" class="p-3 text-start">
            <p>{{'ALTERNATIVE.DISPUTE.INTRODUCTION' | translate}}</p>
            <p>Centro de Arbitragem de Conflitos de Consumo de Lisboa<br><a href="https://www.centroarbitragemlisboa.pt"
                    target="_blank">www.centroarbitragemlisboa.pt</a></p>
            <p>Centro de Arbitragem de Conflitos de Consumo do Vale do Ave / Tribunal Arbitral<br><a
                    href="https://www.triave.pt" target="_blank">www.triave.pt</a></p>
            <p>CIAB - Centro de Informação, Mediação e Arbitragem de Consumo (Tribunal Arbitral de Consumo)<br><a
                    href="https://www.ciab.pt" target="_blank">www.ciab.pt</a></p>
            <p>CNIACC - Centro Nacional de Informação e Arbitragem de Conflitos de Consumo<br><a
                    href="https://www.cniacc.pt" target="_blank">www.cniacc.pt</a></p>
            <p>Centro de Arbitragem de Conflitos de Consumo do Distrito de Coimbra<br><a
                    href="https://www.centrodearbitragemdecoimbra.com"
                    target="_blank">www.centrodearbitragemdecoimbra.com</a></p>
            <p>Centro de Informação, Mediação e Arbitragem de Conflitos de Consumo do Algarve<br><a
                    href="https://www.consumoalgarve.pt" target="_blank">www.consumoalgarve.pt</a></p>
            <p>Centro de Informação de Consumo e Arbitragem do Porto<br><a href="https://www.cicap.pt"
                    target="_blank">www.cicap.pt</a></p>
            <p>Centro de Arbitragem de Conflitos de Consumo da Madeirab<br><a href="https://www.madeira.gov.pt/cacc"
                    target="_blank">www.madeira.gov.pt/cacc</a></p>
            <p>Mais informações em Portal do Consumidor<br><a href="https://www.consumidor.pt"
                    target="_blank">www.consumidor.pt</a></p>
        </section>
    </div>
</section>